const menuItemWidth = 195;

export const getMenuItemStyles = (_, { palette = {} }) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '32px',
    textDecoration: 'none',
    '& > a': {
      width: 'calc(100% + 8px)',
      marginLeft: '-8px',
      paddingLeft: '8px',
      paddingRight: '8px',
      height: '32px !important',
    },
    '& > a:focus': {
      textDecoration: 'none',
      outline: `1px solid ${palette.neutralSecondary}`,
      outlineOffset: -1,
    },
  },
  toggleable: {
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'rgba(0, 0, 0, .1)',
      textDecoration: 'none',
    },
    '&:active': {
      backgroundColor: 'rgba(0, 0, 0, .2)',
      textDecoration: 'none',
    },
    '&:focus': {
      textDecoration: 'none',
    },
  },
  item: {
    height: 32,
    width: 'fit-content',
    maxWidth: menuItemWidth,
    fontFamily: 'Segoe UI',
    fontSize: 14,
    textDecoration: 'none',
    lineHeight: '22px',
    color: palette.neutralPrimary,
    paddingTop: 4,
    position: 'relative',
    display: 'flex',
  },
  itemText: {
    width: 'fit-content',
    maxWidth: menuItemWidth,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    whiteSpace: 'nowrap',
  },
  hiddenTooltip: {
    display: 'none',
  },
  fallbackGlyph: {
    fontSize: '16px',
    paddingLeft: '8px',
    color: palette.themePrimary,
    float: 'right',
    marginRight: '0px !important',
  },
  calloutTargetContainer: {
    display: 'inline-block',
  },
  menuItemTagContainer: {
    position: 'relative',
    display: 'inline-block',
    top: -12,
    marginLeft: -16,
  },
});
